import styled from 'styled-components'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { Button, P, Wrapper } from '@farewill/ui'
import { hideModal } from 'state/actions'

const StyledButtonWrapper = styled(Wrapper)`
  display: flex;
  justify-content: flex-end;
`

const DeleteModal = ({
  config: { documentId, isDeletingDocument, deleteDocument },
}: {
  config: {
    documentId: number
    isDeletingDocument: boolean
    deleteDocument: (id: number) => Promise<void>
  }
}) => {
  const dispatch = useDispatch()

  const onConfirmRemove = async () => {
    await deleteDocument(documentId)
    toast('Document deleted.', {
      toastId: 'document-deleted',
    })
    dispatch(hideModal())
  }

  return (
    <Wrapper>
      <P margin={[0, 0, 'M']}>
        This will hide it from case view. To permanently delete, contact the
        product team.
      </P>

      <StyledButtonWrapper margin={['M', 0]}>
        <Button.Underline
          type="button"
          disabled={isDeletingDocument}
          onClick={() => dispatch(hideModal())}
        >
          Cancel
        </Button.Underline>

        <Button.Primary
          type="button"
          loading={isDeletingDocument}
          onClick={onConfirmRemove}
        >
          Remove
        </Button.Primary>
      </StyledButtonWrapper>
    </Wrapper>
  )
}

export default DeleteModal
